module.exports = __webpack_public_path__ + "img/slider-image-02-isanon.2b1db064.png";